import { observer } from "mobx-react-lite";
import React, { useEffect, useState, useRef } from "react";
import EventLabel from "../../components/EventLabel";
export const Countdown = observer((props) => {
  const [time, setTime] = useState("");
  const [clear, setClear] = useState(false);

  const timerRef = useRef();
  const { settings, environment, small, active } = props;
  const { datetime, timerShadow = false, showZeroes = false, showTitle = false } = settings;
  const { eventId, lang } = environment;
  useEffect(() => {
    const t = new Date();
    timerRef.current = setInterval(() => countdown(t.setSeconds(t.getSeconds() + 1)), 1000);
    return () => clearInterval(timerRef.current);
  }, []);

  useEffect(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    const t = new Date();
    timerRef.current = setInterval(() => countdown(t.setSeconds(t.getSeconds() + 1)), 1000);
    return () => clearInterval(timerRef.current);
  }, [settings.datetime]);

  useEffect(() => {
    if (clear) {
      props.checkHeights();
    }
  }, [clear]);

  const countdown = (currentTime) => {
    if (clear) return;
    let secondsLeft = (new Date(datetime) - new Date(currentTime)) / 1000;
    var delta = Math.abs(datetime - currentTime) / 1000;
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    var seconds = Math.floor(delta % 60);

    if (secondsLeft <= 0) {
      setTime(null);
      setClear(true);
      return;
    }
    setTime({
      days: days < 10 && days > 0 ? "0" + days : days,
      hours: hours < 10 && hours > 0 ? "0" + hours : hours,
      minutes: minutes < 10 && minutes > 0 ? "0" + minutes : minutes,
      seconds: seconds < 10 && seconds > 0 ? "0" + seconds : seconds,
    });
  };

  if (clear) return null;

  if (!time) return null;
  const { days, hours, minutes, seconds } = time;

  if (small)
    return (
      <span className={active ? "tool active pill" : ""}>
        {days} {hours}:{minutes}:{seconds}
      </span>
    );
  return (
    <React.Fragment>
      {showTitle ? (
        <div className="time-badge">
          <div className="time-caption">
            <EventLabel name="RoomOpensIn" groupName="Cms.Countdown" />
          </div>
        </div>
      ) : null}
      <div className="countdown-wrapper">
        {showZeroes || days ? (
          <div className="time-badge">
            <div className={`time-text ${timerShadow ? "smooth-shadow" : ""}`}>{days}</div>
            <div className="time-caption">
              <EventLabel name="Days" groupName="Cms.Countdown" />
            </div>
          </div>
        ) : null}
        {showZeroes || days || hours ? (
          <div className="time-badge">
            <div className={`time-text ${timerShadow ? "smooth-shadow" : ""}`}>{hours}</div>
            <div className="time-caption">
              <EventLabel name="Hours" groupName="Cms.Countdown" />
            </div>
          </div>
        ) : null}
        {showZeroes || days || hours || minutes ? (
          <div className="time-badge">
            <div className={`time-text ${timerShadow ? "smooth-shadow" : ""}`}>{minutes}</div>
            <div className="time-caption">
              <EventLabel name="Minutes" groupName="Cms.Countdown" />
            </div>
          </div>
        ) : null}
        {showZeroes || days || hours || minutes || seconds ? (
          <div className="time-badge">
            <div className={`time-text ${timerShadow ? "smooth-shadow" : ""}`}>{seconds}</div>
            <div className="time-caption">
              <EventLabel name="Seconds" groupName="Cms.Countdown" />
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
});
